import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
*{
    margin:0;
    padding: 0;
    box-sizing: border-box;
    scrollbar-width: thin;
    scrollbar-color: #c562c5 transparent;
    font-family: 'Quicksand', 'Dosis';
  
}

@media screen and (max-width: 520px){
    overflow-x: hidden;
}

body{
    height: 100%;
    background: #1b1b1b;
    overflow-x: hidden;
    font-family: 'Quicksand', sans-serif;
    h2 {
    color: white;
  }
  h3 {
    color: white;
    font-size: 1.5rem;
  }
  h4 {
    color: white;
    font-size: 1.2rem;
  }
  h5 {
    color: white;
    font-size: 0.9rem;
  }
  h6{
      font-size: 1.3rem;
      color: #c562c5;
      text-decoration: none;
      transition: 0.3s ease;
      cursor: pointer;
      margin-top: 2rem;
      &:hover{
        text-decoration: underline;
        color: #6b346b
      }
      @media screen and (max-width: 520px){
          font-size: 2rem;
          margin: -0.3rem 0rem 1rem 0rem;
      }

  }
    
}

/* body::before{
    content: '';
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right top, #23d997, #47e283, #6aea6b, #8ef14d, #b3f61e);
    clip-path: circle(18% at right 85%)
}

body::after{
    content: '';
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right top, #23d997, #00bcba, #0099d3, #0072d0, #2542a9);
    clip-path: circle(10% at 15% 80%);
    z-index: -1;


} */

button{
    font-weight: bold;
    font-size: 1.3rem;
    cursor: pointer;
    padding: 0.6rem 2rem;
    transition: all 0.5s ease-out;
    border: 3px solid transparent;
    &:hover{
        background-color: #23d997;
        color:black
    }
  color: white;
  border-radius: 5px;
  outline: none;
  background: transparent;
  border: 2px solid #23d997;
  text-align: center;
  cursor: pointer;
  font-family: "Quicksand", sans-serif;
  margin-top: 3rem;
}

html{
    &::-webkit-scrollbar{
        width: 6px;
        
    }
    &::-webkit-scrollbar-thumb{
        background-color: #c562c5;
        border-radius: 1.5rem;
        border: transparent;
        
        
    }
    &::-webkit-scrollbar-ms-track{
        background-color: transparent;
        
    }
}

small{
    font-size: 1.3rem;
    color: #c562c5;
    text-decoration: none;
    cursor: default;
    text-align: center;
}

.modal-open{
    overflow: hidden;
}

`

export default GlobalStyle
